import { ADD_CART, REMOVE_CART, RESET_CART, RESET_CART_TIMESLOTS, SET_CART } from "services/redux/action-types";
import { cartConstants } from "services/redux/cart/constants";

export function resetCart() {
	return {
		type: RESET_CART
	}
}

export function resetCartTimeslots() {
	return {
		type: RESET_CART_TIMESLOTS
	}
}

export function setEmployeeStatus( payload ) {
	return {
		type: SET_CART,
		key: cartConstants.EMPLOYEE_STATUS,
		payload: payload
	}
}

export function addCartTimeslots( payload ) {
	return {
		type: ADD_CART,
		key: cartConstants.TIMESLOTS,
		payload: payload
	}
}

export function removeCartTimeslots( payload ) {
	return {
		type: REMOVE_CART,
		key: cartConstants.TIMESLOTS,
		payload: payload
	}
}

export function addCartTimeslotLunchOptions( payload ) {
	return {
		type: ADD_CART,
		key: cartConstants.TIMESLOTS_LUNCH_OPTIONS,
		payload: payload
	}
}
export function removeCartTimeslotLunchOptions( payload ) {
	return {
		type: REMOVE_CART,
		key: cartConstants.TIMESLOTS_LUNCH_OPTIONS,
		payload: payload
	}
}

export function setCartTimeslotTransportDefaultLicensePlate( payload ) {
	return {
		type: SET_CART,
		key: cartConstants.TIMESLOTS_TRANSPORT_DEFAULT_LICENSE_PLATE,
		payload: payload
	}
}

export function setCartTimeslotTransportLicensePlate( payload ) {
	return {
		type: SET_CART,
		key: cartConstants.TIMESLOTS_TRANSPORT_LICENSE_PLATES,
		payload: payload
	}
}
